import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CallBackForm from "./CallBackForm";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import RefreshIcon from "@material-ui/icons/Refresh";
import { IconButton } from "@material-ui/core";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import "../css/css/react-confirm-alert.css";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { green } from "@material-ui/core/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function SearchForm(props) {
  // const [googleMapsReady,setGoogleMaps] = React.useState(props.values.googleMapsReady)
  const backdropScreenRef = React.useRef(null);
  let textInput = React.useRef(null);
  const [selection, setSelection] = React.useState(
    props.values.customerSelection
  );

  const [newFieldsState, setNewState] = React.useState(
    props.values.addressFields
  );

  const [showAddressInvalidError, setShowAddressInvalidError] = React.useState(false)
  const [allAddresses, getAddresses] = React.useState(props.values.addresses);
  const [haveICP, getICPs] = React.useState(props.values.haveICP);
  const [confirmedICP, setICP] = React.useState(props.values.icp);
  const [manualSearch, setManualSearch] = React.useState({});
  const [autoManualSearch, setAutoManualSearch] = React.useState({});
  const [loadingAddress, setLoading] = React.useState(false);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: {
        country: "nz",
      },
    },
  });

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [openModal, setModalOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
    // setLoading(false)
  };
  const [searchInputValue, setSearchInputValue] = React.useState('');
  const [searchTimer, setSearchTimer] = React.useState(0);

  /**
   * get address parameter from URL
   * get icp from address
   * load address and icp into selectedICP()
   */
  const param = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let street_number = param.street_number;
  let route = param.route;
  let unit = param.unit;
  let town = param.town;

  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleChange = (e) => {
    setSelection(e.target.value);
    props.setSelection(e.target.value);
  };

  // const handleInput = (e) => {
  //   // Update the keyword of the input element
  //   setValue(e.target.value);
  // };

  const clearAllState = (e) => {
    //reset address field
    handleClose();
    setLoading(false);
    getICPs(false);
    props.confirmICP(false);
    props.setAddressFromAPI("");
    setValue("");
    setNewState("");
    props.getAddress("");
    setICP("");
    props.setICP("", "");
    getAddresses(0);
    //  textInput.current.focus();
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"

      setValue(description, false);
      clearSuggestions();
      props.getAddress(description);
      const parameter = {
        address: description,
      };

      getGeocode(parameter)
        .then((results) => {
          setOpen(true);
          results[0].address_components.map((address_field) => {
            return setNewState((newFieldsState) => ({
              ...newFieldsState,
              [address_field.types[0]]: address_field.long_name,
            }));
          });
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
      // clearSuggestions();
    };

  //ADDRESS SEARCH: get ICP via address entry
  const getICPAPI = (fields) => {
    if (
      fields instanceof Object === true &&
      (fields.street_number ||
        fields.route !== undefined ||
        fields.locality !== undefined)
    ) {
      setLoading(true);

      let suburbOrTown = "";
      let region = "";
      if (fields.political !== undefined) {
        suburbOrTown = fields.political;
      }
      if (fields.locality !== undefined) {
        region = fields.locality;
      }
      axios
        .post("/home/getICPFromEMI", {
          method: "one",
          streetNumber: fields.street_number,
          streetName: fields.route,
          suburbOrTown: suburbOrTown,
          region: region,
        })
        .then((res) => {
          //         //set loading data... screen off
          handleClose();
          if (res.data.length > 0) {
            getICPs(true);
            props.setAddressFromAPI(res.data);
            props.confirmICP(true);
            getAddresses(res.data);
            setLoading(false);
            setModalOpen(true);
          } else {
            let removeCharFromString = fields.street_number.replace(/\D/g, "");

            axios
              .post("/home/getICPFromEMI", {
                method: "two",
                streetNumber: removeCharFromString,
                streetName: fields.route,
              })
              .then((res) => {
                if (res.data.length > 0) {
                  getICPs(true);
                  props.setAddressFromAPI(res.data);
                  // props.confirmICP(true);
                  getAddresses(res.data);
                } else {
                  setOpen(false);
                  setShowAddressInvalidError(true)
                }
              });
          }
        })
        .catch((error) => {
          setOpen(false);
          console.error(error);
        });
    }
    //reset so modal dialog does nt pop

    props.setAddressFromAPI("");
    getAddresses("");
  };

  const addressValidation = (value) => {
    if (/\S/.test(value)) {
      formatManualAddressEntry(value.trim());
      setShowAddressInvalidError(false)
    } else {
      //alert user to enter address
      setShowAddressInvalidError(true)
    }
  };

  const formatManualAddressEntry = (fields) => {
    let queryAddress = fields;
    let addressArray,
      strtname,
      strtNumber,
      strtNameAndNumber,
      suburb,
      strtNameAndNumberArray = "";

    // if user enters more than street name
    if (!queryAddress.includes(",")) {
      addressArray = queryAddress.split(" ");
      strtNumber = addressArray[0];
      for (let i = 1; i < addressArray.length; i++) {
        if (strtname !== undefined) {
          strtname = strtname + " " + addressArray[i];
        } else {
          strtname = addressArray[i];
        }
      }
    } else if (queryAddress.includes("/")) {
      addressArray = queryAddress.split("/");

      addressArray = addressArray[1].split(",");
      strtname = addressArray[0];
    } else {
      addressArray = queryAddress.split(",");
      suburb = addressArray[1];
      strtNameAndNumber = addressArray[0];
      strtNameAndNumberArray = strtNameAndNumber.split(" ");
      strtNumber = strtNameAndNumberArray[0];
      for (let i = 1; i < strtNameAndNumberArray.length; i++) {
        if (strtname !== undefined) {
          strtname = strtname + " " + strtNameAndNumberArray[i];
        } else {
          strtname = strtNameAndNumberArray[i];
        }
      }
    }

    setManualSearch((manualSearch) => ({
      ...manualSearch,
      ["street_number"]: strtNumber,
      ["route"]: strtname,
      ["suburbOrTown"]: suburb,
    }));

    return manualSearch;
  };

  //ICP search - allow customer to get address via icp - proceed?
  const getICPdetailAPI = (resultICP) => {
    if (resultICP) {
      props.setLoadingScreen(true);
      props.toggleSecondStage();
      axios
        .post("/home/getAddressFromEMIAPI", {
          icp: resultICP,
        })
        .then((res) => {
          props.setAddressFromAPI(res.data[0].Address);

          getAddresses(res.data[0].Address);

          getRatesFromPricingCalculator(resultICP);
          getGasICPDetailAPI(res.data[0].Address);
          getLPGDetailAPI(res.data[0].Address);
        })
        .catch(function (error) {
          setLoading(false);
          props.setLoadingScreen(false);
          props.toggleSecondStage('remove');
          alertMessage(
            "ICP Validation Error",
            "Sorry we were unable to validate your ICP. Please try again or request a call back. "
          );
        });
    } else {
      alertMessage(
        "ICP Validation Error",
        "Sorry we were unable to validate your ICP. Please try again or request a call back. "
      );
    }
  };

  const getRatesFromPricingCalculator = (result) => {

    // const res = {
    //   "success": true,
    //   "data": {
    //       "icpDetail": {
    //           "Address": "21 GALAXY DRIVE, MAIRANGI BAY, AUCKLAND",
    //           "Advanced_Infrastructure": true,
    //           "ChargeableCapacity": "15.00",
    //           "CurrentRetailerName": "Contact-CTCT",
    //           "GXP": "ALB0331",
    //           "HasGas": "false",
    //           "HighestMeteringCategory": 1,
    //           "ICP": "0000229910UN0F7",
    //           "ICPStatus": "Active",
    //           "InstallDetails": "15.00",
    //           "InstallType": "L",
    //           "IsPrepay": false,
    //           "MEP": "MTRX",
    //           "Network": "UNET",
    //           "Number_of_Meters": 1,
    //           "ProductCode": "",
    //           "RegistContentCode": "IN19",
    //           "Registry_Price_Category": "WRHSC",
    //           "UnmeteredLoadTrader": "",
    //           "UserClass": ""
    //       },
    //       "productCode": "1-PRICEPROMISE-PUNN",
    //       "userClass": [
    //           {
    //               "UserClassCode": "002",
    //               "UserClassDescription": "Standard User"
    //           },
    //           {
    //               "UserClassCode": "001",
    //               "UserClassDescription": "Low User"
    //           }
    //       ],
    //       "productDescription": "Pulse Energy Price Promise"
    //   },
    //   "error": {
    //       "title": "",
    //       "message": ""
    //   }
    // };

    // let resultData = res;
    // props.setLoadDetailFromICP(resultData);

    // // If smart meter
    // if (resultData.data.icpDetail.Advanced_Infrastructure == true) {
    //   props.setSmartMeter(resultData.data.icpDetail.Advanced_Infrastructure);
    // }
    // if (resultData.data.icpDetail.RegistContentCode.includes('EG')) {
    //   props.setExportMeter(true);
    // }

    /* Temp Data */
  
    axios.post("/home/callPriceCalculator", 
      {
        icp: result,
      },
    ).then((res) => {
      let result = res.data;
      if (result.success === true) {
        if (props.setLoadDetailFromICP) {
          props.setLoadDetailFromICP(result);
        }
        // If smart meter
        if (result.data.icpDetail.Advanced_Infrastructure == true) {
          props.setSmartMeter(result.data.icpDetail.Advanced_Infrastructure);
        }
        if (result.data.icpDetail.RegistContentCode.includes('EG')) {
          props.setExportMeter(true);
        }
      } else {
        props.toggleSecondStage('remove');
        alertMessage("Oops, something went wrong.", result.error.message);
      }
    }).catch(function (error) {
      props.setLoadingScreen(false);
      props.toggleSecondStage('remove');
      console.log(error)
      alertMessage(
        "Oops, something went wrong.",
        "Sorry we were unable to find your rates.  Please try again or request a call back. "
      );
    });
  };

  //ADDRESS SEARCH: parse confirmed address/icp clicked from MODAL DIALOG
  const selectedICP = (confirmedAddy, icp) => {
    props.setLoadingScreen(true);
    props.toggleSecondStage();
    props.setICP(confirmedAddy, icp);
    setICP(icp);

    getRatesFromPricingCalculator(icp);
    getGasICPDetailAPI(confirmedAddy);
    getLPGDetailAPI(confirmedAddy);
    clearSuggestions();
  };

  const getLPGDetailAPI = (confirmedAddy) => {
    let suburb = "";
    let region = "";

  console.log('LPGGGG!!!')

    // if addy is an object
    if (confirmedAddy instanceof Object === true) {
      suburb = confirmedAddy.PhysicalAddressSuburb;
      region = confirmedAddy.PhysicalAddressRegion;
      if (suburb === "") {
        suburb = confirmedAddy.PhysicalAddressTown;
      }
    }
    // if addy is an array
    if (confirmedAddy instanceof Array === true) {
      for (let i = 0; i < confirmedAddy.length; i++) {
        if (confirmedAddy[i] === false) {
          confirmedAddy[i] = "";
        }
      }

      suburb = confirmedAddy[3].trim();
      region = confirmedAddy[4].trim();
    }

    // let result = {
    //   "data": {
    //       "success": true,
    //       "data": {
    //           "lpgRates": [
    //               {
    //                   "CylinderRefill": 146,
    //                   "CylinderRental": 0.83
    //               }
    //           ],
    //           "urgentDeliveryRates": [
    //               {
    //                   "Weekday": 110,
    //                   "Weekend": 180,
    //                   "PublicHoliday": 420
    //               }
    //           ],
    //           "priceZoneCode": "Auckland3"
    //       },
    //       "error": {
    //           "title": "",
    //           "message": ""
    //       }
    //   }
    // };

    // props.loadLPGRatesDetail(result.data);

    // temp data
    axios.post("/home/getLPGDetailAPI", {
      //pass parameters to back end to get gas ICP and rates from Pricing Calculator
      suburb: suburb,
      region: region,
    }).then((res) => {
      //returns lpgRates array
      let result = res.data;
      props.loadLPGRatesDetail(result.data);
    }).catch(function (error) {
      console.error(error);
    });
  };

  // get Natural Gas ICP from selected Address
  const getGasICPDetailAPI = (confirmedAddy) => {
    let strtNumber = "";
    let strtName = "";
    let suburb = "";
    let region = "";


  console.log('2GASSS!!!')

    // if addy is an object
    if (confirmedAddy instanceof Object === true) {
      strtNumber = confirmedAddy.PhysicalAddressNumber;
      strtName = confirmedAddy.PhysicalAddressStreet;
      suburb = confirmedAddy.PhysicalAddressSuburb;
      region = confirmedAddy.PhysicalAddressRegion;
    }
    // if addy is an array
    if (confirmedAddy instanceof Array === true) {
      for (let i = 0; i < confirmedAddy.length; i++) {
        if (confirmedAddy[i] === false) {
          confirmedAddy[i] = "";
        }
      }
      strtNumber = confirmedAddy[1].trim();
      strtName = confirmedAddy[2].trim();
      suburb = confirmedAddy[3].trim();
      region = confirmedAddy[5].trim();
    }
    props.setSuburbAndRegion(suburb, region);

    const northIslandRegions = [
      "auckland",
      "northland",
      "waikato",
      "bay of plenty",
      "gisborne",
      "manawatu-wanganui",
      "manawatu",
      "wanganui",
      "hawkes bay",
      "taranaki",
      "wellington",
    ];
    let isNorthIsland = northIslandRegions.includes(region.toLowerCase());

    //if (isNorthIsland) {

      // let result = {
      //   "success": false,
      //   "data": [],
      //   "error": {
      //       "title": "",
      //       "message": ""
      //   }
      // };

      // if (result.success === true) {
      //   props.setLoadGasDetailFromICP(result);
      // }

      /* Temp Data */
      axios
        .post("/home/getGasICPDetail", {
          // pass parameters to back end to get gas ICP and rates from Pricing Calculator
          strtNumber: strtNumber,
          strtName: strtName,
          suburb: suburb,
          region: region,
        })
        .then((res) => {
          //returns gasRates array
          let result = res.data;

          if (result.success === true) {
            props.setLoadGasDetailFromICP(result);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
   // }
  };

  /**
   * Set address
   * Call getICPFromEMI api with url params 
   */
  const setAddress = () => {
    axios.post("/home/getICPFromEMI", {
      method: "one",
      streetNumber: street_number,
      streetName: route,
      suburbOrTown: '', 
      region: ''
    }).then((res) => {

      console.log('jed 3');

      let autoAddy = [];
      if (unit != null) {
        // if unit
        let units   = res.data;
        let autoICP = '';
        for (var i = 0; i<units.length; i++) {
          if (units[i].Address.PhysicalAddressUnit === unit) {
            let address = units[i].Address;
            autoAddy = [
              ` ${address.PhysicalAddressUnit}/`,
              ` ${address.PhysicalAddressNumber}`,
              ` ${address.PhysicalAddressStreet}`,
              ` ${address.PhysicalAddressSuburb}`,
              ` ${address.PhysicalAddressTown}`,
              ` ${address.PhysicalAddressRegion}`,
              ` ${address.PhysicalAddressPostCode}`
            ];
            autoICP = units[i].ICPIdentifier;
          }
        }
        // set Address and ICP
        selectedICP(autoAddy, autoICP)
      } else {
        // if not unit 
        let address = res.data[0].Address;
        autoAddy = [
          ` `,
          ` ${address.PhysicalAddressNumber}`,
          ` ${address.PhysicalAddressStreet}`,
          ` ${address.PhysicalAddressSuburb}`,
          ` ${address.PhysicalAddressTown}`,
          ` ${address.PhysicalAddressRegion}`,
          ` ${address.PhysicalAddressPostCode}`
        ]; 
        // set Address and ICP
        selectedICP(autoAddy, res.data[0].ICPIdentifier)
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  const loadingAddressLoader = () => {
    return (
      <Backdrop
        className={classes.backdrop}
        ref={backdropScreenRef}
        open={open}
      >
        {/* <Loader style={{textAlign:'center'}} type="ThreeDots" color="rgb(89, 169, 70)" height={80} width={80}/> */}
        <CircularProgress fontSize="small" style={{ color: "#00696a" }} />
      </Backdrop>
    );
  };

  const alertMessage = (messageTitle, message) => {
    return confirmAlert({
      title: messageTitle,
      message: message,
      buttons: [
        {
          label: "Try again",
          onClick: () => clearAllState(),
        },
        {
          label: "Request a call back",
          onClick: () => setCallBackOnClick("callback"),
        },
      ],
      // willUnmount: () => {}
    });
  };

  const setCallBackOnClick = (input) => {
    setSelection(input);
    props.setSelection(input);
  };

  React.useEffect(() => {
    // if auto address is false
    if (!props.values.autoAddress) {
      // if params are in url
      if (street_number != null && route != null) {
        // set auto address to true
        props.setAutoAddress(true)
        // set address
        setAddress();
      }
    }
  }, [props.values.autoAddress]);

  React.useEffect(() => {
    props.format_address(newFieldsState);

    if (selection !== props.values.customerSelection) {
      setSelection(props.values.customerSelection);
    }

    if (newFieldsState.postal_code !== "" && newFieldsState.postal_code !== undefined) {
      getICPAPI(newFieldsState);
      window.dataLayer.push({
        'event': 'sign_up_step',
        'screenDescription': 'address_popup'
      });
      setNewState("");
    }

    if (Object.keys(manualSearch).length > 0 && manualSearch.constructor === Object && searchInputValue.length > 5) {
      getICPAPI(manualSearch);
      window.dataLayer.push({
        'event': 'sign_up_step',
        'screenDescription': 'address_popup'
      });
      setNewState("");
    }
  }, [
    newFieldsState.postal_code,
    manualSearch,
    props.values.customerSelection,
  ]);

  const onKeyPressHandler = (e) => {
    if (e.keyCode === 13) {
      if (props.values.customerSelection === "icp") {

        // Track the button click
        trackButtonClick('enter_address_find_my_price', {
          'address_value': value,
          'search_method': 'address_manual'
        });

        getICPdetailAPI(props.values.icp);
      } else {
        //if address value is not empty then search manually
        addressValidation(value);
      }
    }
  };

  // New Adition

  const handleInput = e => {
    const inputValue = e.target?.value;

    setSearchInputValue(inputValue);

    if (!inputValue || inputValue.length < 5) {
        setShowAddressInvalidError(false);
        getAddresses(0);
    }

    if (searchTimer != null) {
        clearTimeout(searchTimer);
    }

    const newTimer = setTimeout(() => {
        if (inputValue && /\S/.test(inputValue)) {
            formatAutoManualAddressEntry(inputValue.trim());
        }
    }, 500);

    setSearchTimer(newTimer);
  };

  const formatAutoManualAddressEntry = (fields) => {
    let queryAddress = fields;
    let addressArray,
      strtname,
      strtNumber,
      strtNameAndNumber,
      suburb,
      strtNameAndNumberArray = "";

    // addressArray= queryAddress.split(" ");

    // if user enters more than street name
    if (!queryAddress.includes(",")) {
      addressArray = queryAddress.split(" ");
      strtNumber = addressArray[0];
      for (let i = 1; i < addressArray.length; i++) {
        if (strtname !== undefined) {
          strtname = strtname + " " + addressArray[i];
        } else {
          strtname = addressArray[i];
        }
      }
    } else if (queryAddress.includes("/")) {
      addressArray = queryAddress.split("/");

      addressArray = addressArray[1].split(",");
      strtname = addressArray[0];
    } else {
      addressArray = queryAddress.split(",");
      suburb = addressArray[1];
      strtNameAndNumber = addressArray[0];
      strtNameAndNumberArray = strtNameAndNumber.split(" ");
      strtNumber = strtNameAndNumberArray[0];
      for (let i = 1; i < strtNameAndNumberArray.length; i++) {
        if (strtname !== undefined) {
          strtname = strtname + " " + strtNameAndNumberArray[i];
        } else {
          strtname = strtNameAndNumberArray[i];
        }
      }
    }

    setAutoManualSearch((autoManualSearch) => ({
      ...autoManualSearch,
      ["street_number"]: strtNumber,
      ["route"]: strtname,
      ["suburbOrTown"]: suburb,
    }));

    return autoManualSearch;
  };

  React.useEffect(() => {
    props.format_address(newFieldsState);

    if (Object.keys(autoManualSearch).length > 0 && autoManualSearch.constructor === Object) {
      if (autoManualSearch.route !== undefined && autoManualSearch.street_number !== undefined && searchInputValue.length > 5) {
        getICPAPI(autoManualSearch);
      }
    }
  }, [
    newFieldsState.postal_code,
    autoManualSearch,
    props.values.customerSelection,
  ]);

  const renderSuggestions = () => allAddresses.map((suggestion, index) => {
    // Only render first 10 addresses
    //if (index > 10) return

    const { ICPIdentifier, Address } = suggestion;
    const {
      GPS_Easting,
      GPS_Northing,
      PropertyNameOrDescription,
      ...withoutGPS
    } = Address;

    if (withoutGPS.PhysicalAddressUnit !== "") {
      withoutGPS.PhysicalAddressUnit = withoutGPS.PhysicalAddressUnit + "/";
    }

    let addressObject = Object.entries(withoutGPS);

    const addressData = addressObject.map(
      ([key, value], i) => value !== "" && " " + value
    );

    const eachAddress = `${addressObject[0][1]}${addressObject[1][1]} ${formatString(addressObject[2][1])}, ${formatString(addressObject[4][1])}, ${addressObject[5][1]} ${checkPostcode(addressObject[6][1])}` ;

    return (
      <li onClick={() => selectedICP(addressData, ICPIdentifier)} key={index}>
        <RoomOutlinedIcon />
        {eachAddress}
      </li>
    );
  });

  const formatString = (string) => {
    let text = string.toLowerCase().split(' ');

    for (var i = 0; i < text.length; i++) {
      text[i] = text[i].charAt(0).toUpperCase() + text[i].substring(1);
    }

    return text.join(' ');
  }

  const checkPostcode = (value) => {
    if (value > 0) {
      return value;
    } else {
      return '';
    }
  }

  const trackButtonClick = (buttonName, additionalData = {}) => {
    if (typeof window.gtag !== 'undefined') {

      console.log('Tracking event 1');

      // Force immediate send with beacon transport
      window.gtag('config', 'G-GWQNXWB6G7', {
        'transport_type': 'beacon'
      });

      console.log('Tracking event 2');

      window.gtag('event', buttonName, {
        'button_name': buttonName,
        'button_location': 'search_form',
        'timestamp': new Date().toISOString(),
        ...additionalData
      });

      console.log('Tracking event:', buttonName, {
        'button_name': buttonName,
        'button_location': 'search_form',
        'timestamp': new Date().toISOString(),
        ...additionalData
      });
    } else {
      console.warn('gtag is not defined');
    }
 };

  return (
    <div className="innerSearchForm">
      {loadingAddress && loadingAddressLoader()}

      <FormControl component="fieldset" id="searchFormFieldset">
        <RadioGroup
          aria-label="searchForm"
          name="searchForm"
          defaultValue="address"
          value={selection}
          onChange={handleChange}
        >
          {
            selection === "icp" && <FormControlLabel
                                    value="address"
                                    control={<Radio />}
                                    label="Enter your address"
                                  />
          }

          {/* Show address textfield if address is selected */}
          {selection === "address" && (
            <div
              ref={ref}
              className="address-search-wrapper"
            >
              <TextField
                autoFocus
                placeholder="Start typing your address"
                autoComplete="off"
                inputRef={textInput}
                fullWidth
                style={{}}
                name="address"
                type="text"
                variant="standard"
                // margin="normal"
                className="address-finder"
                onKeyDown={(e) => {
                  onKeyPressHandler(e);
                }}
                value={searchInputValue}
                onChange={handleInput}
              />
              {
                searchInputValue && searchInputValue.length > 4 && showAddressInvalidError && (
                    <div className="addressSuggestion"><p>Sorry, we couldn't find that address. Please check the spelling or try a different search.</p></div>
                )
              }
              {
                allAddresses.length > 0 && (
                  <div className="addressSuggestion">
                    <ul>{renderSuggestions()}</ul>
                  </div>
                )
              }
            </div>
          )}

          <FormControlLabel
            value="icp"
            control={<Radio />}

            label="Enter your ICP manually"
          />

          {/* Show icp textfield if icp is selected */}
          {selection === "icp" && (
            <div
              className="address-search-wrapper"
            >
              <TextField
                fullWidth
                placeholder="Type your ICP here"
                style={{}}
                name="icp"
                type="text"
                variant="standard"
                className="manual-address-finder"
                autoFocus
                value={props.values.icp}
                onChange={props.handleChange("icp")}
                onKeyDown={(e) => {
                  onKeyPressHandler(e);
                }}
                inputProps={{ maxLength: 15 }}
                helpertext="15 digits which can be found on the back of your bill"
              />

              <button
                className="get-price-btn"
                onClick={() => {
                  // Track the button click
                  trackButtonClick('enter_icp_find_my_price', {
                    'icp_value': props.values.icp,
                    'search_method': 'icp_manual'
                  });
                  
                  // Original functionality
                  getICPdetailAPI(props.values.icp);
                }}
              >
                find my price
              </button>

            </div>
          )}
          {selection === "callback" && (
            <CallBackForm
              values={props.values}
              handleChange={props.handleChange}
            />
          )}
        </RadioGroup>
      </FormControl>
    </div>
  );
}